import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.scss']
})
export class ModalLoginComponent implements OnInit {
  loginForm:FormGroup 
 
  constructor(
    public dialogRef: MatDialogRef<ModalLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public loginData: any
  ) {


  }

  go() {
    var d = this.dialogRef;
    var c = this.loginForm.value;
    var m = this.loginData;
    if(!m.validation) d.close(c)
    else m.validation(this.loginForm.value).subscribe({
        next(response){
          if(!response)d.close(c)
          else m.message=response;
        },
        error(response){
          m.message=response;
        }
      }
    )
  }


  ngOnInit() {
    this.loginForm= new FormGroup({
      username: new FormControl('', [
        Validators.required
      ]),
      password: new FormControl('', [
        Validators.required
      ])
    })

  }

}